import { createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d5b8f40e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header-pc"
};
const _hoisted_2 = {
  class: "left"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.comentropy.org/"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://www.comentropy.org/wp-content/uploads/2023/06/cropped-WechatIMG329.png",
  alt: "",
  class: "logo"
})], -1));

const _hoisted_4 = {
  class: "right"
};
import BackIcon from '../icon/back-icon.vue';
import UserInfo from './user-info.vue';
import { computed } from 'vue';
import useUserStore from '@/store/modules/user';
import { useRouter } from 'vue-router';
import { USER_LOGIN_IP } from '@/service/request/config.js';
export default {
  __name: 'header-pc',

  setup(__props) {
    const userStore = useUserStore(); // const loginUrl = computed(() => {
    //   const currentUrl = window.location.href
    //   console.log(currentUrl)
    //   return (
    //     ' https://www.uniaccount.org/login?org=comentropy&app=download_center&goto=' +
    //     currentUrl
    //   )
    // })

    const handleLogin = () => {
      const currentUrl = window.location.href;
      window.location.href = USER_LOGIN_IP + '/login?org=comentropy&app=download_center&goto=' + currentUrl; // window.location.href =
      //   'https://www.uniaccount.org/login?org=comentropy&app=download_center&goto=' +
      //   currentUrl
    };

    const router = useRouter();

    const handleTo = path => {
      router.push(path);
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", {
        class: "title",
        onClick: _cache[0] || (_cache[0] = $event => handleTo('/item-list'))
      }, "下载中心")]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", {
        class: "login-btn",
        onClick: handleLogin
      }, " 登录 ", 512), [[_vShow, !_unref(userStore).token]]), _withDirectives(_createVNode(UserInfo, null, null, 512), [[_vShow, _unref(userStore).token]])])]);
    };
  }

};